import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';


// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDHnk-uZjUu2RghLHwbLbhOPlAIflS3RQo",
    authDomain: "tattookolin-82cfb.firebaseapp.com",
    projectId: "tattookolin-82cfb",
    storageBucket: "tattookolin-82cfb.appspot.com",
    messagingSenderId: "590700594457",
    appId: "1:590700594457:web:f573673b17c1038cac7188"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

const projectAuth = getAuth(app);
const projectFirestore = getFirestore(app);
const projectStorage = getStorage(app);

export { projectAuth, projectFirestore, projectStorage };